// const BannerData = {
//   videoUrl:
//     "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Clavis%2FThe%20Clavis%20-%20Arriving%20Soon_.mp4?alt=media&token=345416d0-dce0-4f23-984f-9081bc025bab",
//   title: "The Clavis Arriving Soon",
//   subtitle: "Stay Tuned.",
//   price: "",
//   features: [],
// };


// export {
//   BannerData,

// }


const BannerData = {
  // videoUrl: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Clavis%2FKia%20Carens%20Clavis.mp4?alt=media&token=a0395020-80d7-4f63-a4f6-4909739ccf6a",
   imageUrl:"https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FClavis2Fclavis_d.avif?alt=media&token=c90cb77b-c9e1-413b-868b-a5614860cf09",
   mobileImageUrl:"https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Clavis%2Fbanner%2Fclavis_m.webp?alt=media&token=54f258e9-af92-493f-b476-b647ce7fbf9a",
  title: "The Carens Clavis",
  subtitle: "For epic journeys.",
  price: "₹11 20 900*",
  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FADAS.avif?alt=media&token=f2111e29-4709-4dc0-a44b-5478184e5e4f",
      text: "ADAS Level 2 with 20 Autonomous Safety Features",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FSunroof.avif?alt=media&token=688e2e91-3262-43db-8d23-21254ed75552",
      text: "Dual Pane Panoranic Sunroof",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FRobust-feature.avif?alt=media&token=08906d3b-37a0-4013-88f0-4545b3e7cfc2",
      text: "Robust 18 Hi-Safety Features as Standard",
    },
  ],
};

const IntroData = {
  heading: "THE PERFECT FAMILY CAR",
  subheading: "Introducing The Carens Clavis.",
  description:
    "Inspired by the Latin phrase Clavis Aurea, meaning “Golden Key,” the Clavis is designed to unlock a world of epic journeys and family connections. Every detail is thoughtfully crafted, from spacious interiors to cutting-edge innovation, making it the perfect companion for road trips, everyday drives, and everything in between.",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fperfect%20f.webp?alt=media&token=7ae4053f-6e9d-40d1-bc8c-abceecbf10b9",
};

const InterestDealerData = {
  disclaimer: "",
  register:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2Fregister%20intrest.png?alt=media&token=2c5fb2a2-418b-4399-8994-8e590bd17314",
  dealer:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FBrochure%20image.png?alt=media&token=5ce8b8e6-2d25-41f1-b458-69aa2bd51a10",
};

// const CarouselData = [
//   {
//     sub: "X-Line",
//     title: "The wild experience you can't resist.",
//     data: "Presenting the new Sonet X-Line, now wilder than ever. Explore the wild allure of the exclusive Matte Graphite exterior, embracing a cabin experience that defies resistance. Ready to set the stage for envy as you journey through diverse horizons, this subcompact SUV in India is designed to captivate and impress.​​",
//     carData: [
//       {
//         title: "R16 40.56cm (16”) Sporty Crystal Cut Alloy Wheels",
//         description:
//           "A distinctive design, featuring untamed crystal-cut patterns on a sleek black surface, is the perfect blend of sporty look with performance.",
//         media:
//           "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fx1.jpg?alt=media&token=ba184f7e-3573-4f9e-a157-44a3d27b0de6",
//       },
//       {
//         title:
//           "Kia Signature Tiger Nose Grille with Knurled Xclusive Black High Gloss Surround",
//         description:
//           "Bring out the wild in you with the fierce Kia Signature Tiger Nose grille, while the knurled glossy surround adds a touch of wild charm.​",
//         media:
//           "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fx2.jpg?alt=media&token=4ff9b49c-2fb5-4b14-bfeb-28c696450b61",
//       },
//       {
//         title: "All Door Power Window One Touch Auto Up/Down with Safety",
//         description:
//           "Effortlessly control all windows with a single touch while ensuring safety with auto-stop, in case of obstructions.",
//         media:
//           "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fx3.png?alt=media&token=69ad2bd6-4ee9-469c-b5f7-123f18a50f9a",
//       },
//       {
//         title: "Full Digital Cluster with 26.04cm (10.25') Color LCD MID",
//         description:
//           "Embrace a futuristic instrument cluster that features a comprehensive and sleek interface to make every journey convenient and immersive.",
//         media:
//           "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fx4.jpg?alt=media&token=7cba3a1c-58a2-4be9-9fea-fcee4f872385",
//       },
//     ],
//   },
// ];

const CarouselData1 = [
  {
    sub: "EXTERIOR",
    title: "Every detail tailor-made for your family.",
    data: "The Carens Clavis boasts a bold, futuristic stance that is sure to turn heads. Every element is crafted to captivate, from the Ice Cube MFR LED Headlamps to the signature Digital Tiger Face. At the rear, the striking Star Map LED Connected Tail Lamps complete the look, making Carens Clavis not just a vehicle, but a visual statement.",
    carData: [
      {
        title: "R17 - 43.66 cm (17) Crystal Cut Dual Tone Alloy Wheels",
        description:
          "Designed to trn heads at every corner,these wheels will take your drive up a notch.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery1.webp?alt=media&token=ed7bf40b-b1a5-402c-a11f-d190c3c35869",
      },
      {
        title: "Robust Front & Rear Skid Plates with Satin Chrome Finish",
        description:
          "Add a layer of toughness and flair for all your road trips,city drives,or weekend geatways with the kids.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery2.webp?alt=media&token=91f829fc-3fce-4d95-aaf3-dc4941a843bf",
      },
      {
        title: "Ice Cube MFR LED Headlamps",
        description:
          "Illuminate the road ahead with cutting-edge precision, ensuring your loved ones always travel in safety and style.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery3.webp?alt=media&token=d36cbc12-a7a8-4639-ad10-620ccb43b431",
      },
      {
        title: "Star Map LED Connected Tail Lamps",
        description:
          "A signature look that lights the way, leaving an indelible impression.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery4.webp?alt=media&token=39320341-e78c-46ef-b921-fb04d3486122",
      },

      {
        title: "Dual Pane Panoramic Sunroof",
        description: "Let the sunshine in! A wide, stunning view that brightens every family ride.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery5.webp?alt=media&token=d13bd270-ec42-4a6e-933f-41a9f1c62fe1",
      },
      {
        title: "Kia Digital Tiger Face with Diamond Finish Decor",
        description: "Command attention on every journey.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fevery6.webp?alt=media&token=d28caf74-94f6-41e5-952f-acd776910241",
      },
    ],
  },
  {
    sub: "INTERIOR",
    title: "Welcome your world inside.",
    data: "In the Carens Clavis, comfort isn’t an after-thought, it is weaved into every detail. The 7-seater cabin offers generous space across all three rows, while the Dual Panoramic Display blends seamlessly into the cabin, keeping navigation and entertainment within easy reach.",
    carData: [
      {
        title: "67.62 cm (26.62”) Dual Panoramic Display Panel",
        description:
          "Navigate, control, and entertain with a seamless interface the whole family can enjoy.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside1.webp?alt=media&token=848a7af7-a1bd-4bcb-a657-95cf1391455c",
      },
      {
        title: "Infotainment-Temperature control swap switch",
        description:
          "Adjust climate settings with a simple switch for the full house.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside2.webp?alt=media&token=dbd66f2a-53d6-421e-95eb-dab8bb67b481",
      },
      {
        title: "4-Way Power Driver Seat",
        description: "Drive with ease and confidence, whether it's the school run or a weekend trip.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside3.webp?alt=media&token=d1e37ecb-bd09-4b14-bde9-0f40353d6602",
      },
      {
        title: "Front Ventilated Seats",
        description: "Stay cool and composed during long drives or summer adventures.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside4.webp?alt=media&token=15b3bdf1-f8cd-4ba4-9d74-668eb4eb6e46",
      },
      {
        title: "Smart Pure Air Purifier with AQI Display",
        description:
          "Breathe easy with your loved ones. This purifier keeps the cabin air fresh and safe, no matter where you drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside5.webp?alt=media&token=1489b27e-09e8-411e-9a39-cf83176dca4c",
      },

      {
        title: "BOSE Premium Sound System with 8 Speakers",
        description:
          "Turn every family drive into a concert on wheels with immersive sound that brings everyone together.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Finside6.webp?alt=media&token=798bacbc-7054-482c-b7cc-59ea163b381c",
      },


    ],
  },
  {
    sub: "PERFORMANCE",
    title: "A powerful family ride.",
    data: "Designed to handle everything from everyday errands to full-family road trips—smooth, capable, and efficient.",
    carData: [
      {
        title: "SmartStream G1.5 T-Gdi Petrol Engine",
        description: "Experience dynamic power and smooth efficiency that make every family journey exciting, whether it is city drives or out-of-town adventures.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FClavisPer-1.webp?alt=media&token=9a25eddc-1ca8-4b6e-86f7-de0d12abd72e",
      },
      {
        title: "SmartStream G1.5 Petrol Engine",
        description: "Reliable, fuel-efficient, and ready for anything. Power your daily family life with ease and confidence.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FClavisFPer-2.webp?alt=media&token=1d5d880a-0578-41d1-ac1b-57dc92c5312a",
      },
      {
        title: "1.5l CRDi VGT Diesel Engine",
        description: "Strong, efficient, and built for longer journeys, this diesel engine ensures a powerful yet economical ride for the whole family.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2FClavisFPer-3.webp?alt=media&token=477da21c-c831-48c6-b4a1-6f60247f37fd",
      },
    ],
  },
  {
    sub: "SAFETY",
    title: "Family-first car that puts safety first.",
    data: "Every drive in the Carens Clavis is backed by Kia’s uncompromising commitment to safety. With 18 standard safety features, including 6 Airbags, Electronic Stability Control, Rear Occupant Alert, peace of mind isn’t optional, it’s built-in",
    carData: [
      {
        title: "6 Airbags as Standard ",
        description:
          "Comprehensive protection for all passengers, ensuring everyone rides securely.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fstab1.webp?alt=media&token=57c0fdae-6677-4278-a58d-54dce4ef71d6",
      },
      {
        title:
          "ESC, HAC, VSM, DBC, ABS, BAS",
        description:
          "Stay confidently in control with systems that support braking, hill starts, and dynamic stability during every drive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fstab2.webp?alt=media&token=c7175d7c-058a-459e-a1a5-153ce967b7f2",
      },
      {
        title: "All Wheel Disc Brakes",
        description:
          "Smoother, safer stops, whether in the city or on the highway.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fstab3.webp?alt=media&token=e9af980d-368c-4153-a1e1-f43721e7ba32",
      },
    ],
  },
  {
    sub: "INTUITION",
    title: "Next Level of Intelligent Safety.",
    data: "The Carens Clavis is equipped with ADAS Level 2 featuring 20 autonomous safety functions that work actively to protect you and your loved ones. From Forward Collision Assist and Lane Keep Assist to Blind Spot Collision Warning, it’s a smart co-driver that helps you stay aware, avoid risks, and drive with greater confidence, every single time.",
    carData: [
      {
        title: "Forward Collision Warning and Avoidance Assist (FCW &amp; FCA)",
        description: "Stay one step ahead and detect potential collisions.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fnext1.webp?alt=media&token=a781f4d4-d0a5-49be-9e0c-0faab84469cb",
      },
      {
        title: "Smart Cruise Control (SCC) with Stop &amp; Go",
        description:
          "Automatically maintains distance and manages stop-and-go traffic.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fnext2.webp?alt=media&token=70674544-27d5-464c-874f-5bc894074144",
      },
      {
        title: "Lane Keep Assist (LKA)",
        description:
          "Keeps you in your lane by providing steering assistance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fnext3.webp?alt=media&token=7642bd1b-bea3-4c27-916d-51495c6a7432",
      },
    ],
  },
  {
    sub: "NEXT LEVEL OF CONNECTION",
    title: "Kia Connect 2.0.",
    data: "Embrace the future with Kia Connect 2.0 — an evolved, tech-forward system that brings over 80 smart features to your fingertips. Whether you're inside the car or miles away, Kia Connect 2.0 offers intelligent, real-time control for a safer, more personalized, and effortlessly convenient driving experience.",
    carData: [
      {
        title: "All Window Up/Down Through Smart Key",
        description:
          "Roll down or up your windows through smart key, keeping your family comfortable before you even get in.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fco1.webp?alt=media&token=0198a41c-b07f-44a6-b312-6c2931e618c9",
      },
      {
        title: "Find My Car with Surround View Monitor",
        description:
          "Never lose your car in a crowded lot again with next level connection.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fco2.webp?alt=media&token=e9576cd2-768b-4243-8c52-cdf55aa45d68",
      },
      {
        title: "Multilingual VR Commands",
        description:
          "Navigate seamlessly with voice commands in multiple languages.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fco3.webp?alt=media&token=f339dfc4-49b5-417e-9c2a-db02489a4951",
      },
    ],
  },
];

const TrimData = [
  {
    title: "HTE",
    cost: "11,20,900",
    feature1: "",
    feature2: "Robust 18 Hi-Safety Package ",
    feature3: "2nd Row Seat 'One Touch Easy Electric Tumble'",
    feature4: "Roof Flushed 2nd and 3rd Row Diffused AC Vents",
    feature5: "3rd row 60:40 Split Seats With Sliding Recycling and Full Flat Folding",
    feature6: "5 USB Type C Ports",
    feature7: "Keyless Entry with Burglar Alarm",
  },
  {
    title: "HTE (O)",
    cost: "12,16,900",
    feature1: "",
    feature2: "Robust 18 Hi-Safety Package",
    feature3: "2nd Row Seat “One Touch Easy Electric Tumble”",
    feature4: "2nd row 60:40 Split Seats with Sliding, Reclining and Tumble",
    feature5: "3rd row 50:50 Split Seats with Reclining and Full Flat Folding",
    feature6: "31.7 cm (12.5”) Full Segment LCD Cluster with Advanced (10.5 cm) 4.2' Color TFT MID",
    feature7: "20.32 cm (8.0') Touchscreen with Android Auto, Apple CarPlay",
    feature8: "Electric Adjust Outside Mirrors with LED turn signal",
  },
   {
    title: "HTE (EX)",
    cost: "12,67,900",
    feature1: "Robust 18 Hi-Safety Package",
    feature2: "2nd Row Seat “One Touch Easy Electric Tumble”",
    feature3: "Roof Flushed 2nd and 3rd Row Diffused AC Vents",
    feature4: "2nd Row 60:40 Split Seats with Sliding, Reclining and Tumble",
    feature5: "3rd row 50:50 Split Seats with Reclining and Full Flat Folding",
    feature6: "5 USB Type C Ports",
    feature7: "Keyless Entry with Burglar Alarm",
    feature8: "",
  },
  // {
  //   title: "HTK",
  //   cost: "13,00,509",
  //   feature1: "",
  //   feature2: "Robust 18 Hi-Safety Package",
  //   feature3: "2nd row 60:40 Split Seats with Sliding, Reclining and Tumble",
  //   feature4: "Front Parking Sensors (4)",
  //   feature5: "20.32 cm (8.0') Touchscreen with Android Auto, Apple CarPlay",
  //   feature6:
  //     "Electric Adjust Outside Mirrors with LED turn signal",
  //   feature7: "Premium Fabric with Semi-leatherette seats (Black)",
  //   feature8: "Star Map LED DRLs",
  // },
  {
    title: "HTK+",
    cost: "15,17,990",
    feature1: "",
    feature2: "Robust 18 Hi-Safety Package",
    feature3: "2nd row 60:40 Split Seats with Sliding, Reclining and Tumble",
    feature4: "Auto Cruise Control with manual Speed limit assist",
    feature5: "20.32 cm (8.0') Touchscreen with Android Auto, Apple CarPlay",
    feature6: "Star Map LED DRLs",
    feature7: "Smart Key Remote Engine Start",
    feature8: "Smart Key with Push Button Start & Motion Sensor"
  },
  {
    title: "HTK+(O)",
    cost: "16,19,900",
    feature1: "",
    feature2: "20.32 cm (8.0') Touchscreen with Android Auto, Apple CarPla",
    feature3: "2nd row 60:40 Split Seats with Sliding, Reclining and Tumble",
    feature4: "Rear Wiper and Washer",
    feature5: "Cruise Control with manul speed limit assist ",
    feature6: "SmartPhone Wireless Charger ",
    feature7: "Rear Defogger",
    feature8: "Sky Light Electric Sunroof (G1.5T & D1.5)"
  },

  {
    title: "HTX",
    cost: "17,85,900",
    feature1: "",
    feature2: "Dual Pane Panoramic Sunroof(G1.5T)",
    feature3: "Next Generation Kia Connect With OTA Map and System Updates",
    feature4:
      "31.12 cm (12.25) HD Touchscreen Navigation With Kia Connect",
    feature5: " Cruise Control with manual Speed limit assist ",
    feature6:
      "Smart Pure Air Purifier With AQI Display ",
    feature7: "360 Degree Camera",
    feature8: "Blind View Monitor in Cluster"
  },
    {
    title: "GTX",
    cost: "19,80,900",
    feature1: "Dual Pane Panoramic Sunroof (G1.5T) ",
    feature2: "360 Degree Camera",
    feature3: "Blind View Monitor in Cluster",
    feature4:
      "Next Generation Kia Connect with OTA Map and System Updates",
    feature5: " Smart Pure Air Purifier with AQI Display ",
    feature6:
      "Black Leatherette Seats &amp; Ofwhite Accents",
    feature7: "4-Color Ambient Lighting ",
    feature8: ""
  },

  {
    title: "HTX(O)",
    cost: "19,39,900",
    feature1: "",
    feature2: "2nd Row Captain Seats with Sliding, Reclining and Tumble [6 Seater]",
    feature3: "BOSE Premium Sound System with 8 Speakers",
    feature4:
      "Dual Pane Panoramic Sunroof (G1.5T)",
    feature5: " Drive Mode(DCT) ",
    feature6:
      "Smart Key Remote Engine Start ",
    feature7: "Electric Parking Brake with Auto Hold (7DCT)",
    feature8: "Next Generation Kia Connect With OTA Map and System Updates"
  },
  {
    title: "HTX(O)A",
    cost: "19,85,900",
    feature1: "ADAS Level 2 with 20 Autonomous Features ",
    feature2: "Dual Pane Panoramic Sunroof (G1.5T)",
    feature3: "360 Degree Camera",
    feature4: "Blind View Monitor in Cluster",
    feature5: "Next Generation Kia Connect with OTA Map and System Updates",
    feature6:
      "64-Color Ambient Lighting  ",
    feature7: "BOSE Premium Sound System with 8 Speakers ",
    feature8: "",
  },
  {
    title: "HTX+",
    cost: "18,81,900",
    feature1: "",
    feature2: "ADAS Level2 with 20 Autonomous Features(DCT)",
    feature3: "Front Ventilated Seats",
    feature4: "Dual Pane Panoramic Sunroof(G1.5T)",
    feature5: "360 Degree Camera",
    feature6:
      "2nd Row Captian Seats With Sliding,Reclining ana Tumble[6 Seater] ",
    feature6: "Next Generation Kia Connect With OTA Map and System Updates",
    feature7: "Paddle Shifters (DCT Only)",
  },

  {
    title: "GTX+",
    cost: "21,56,900",
    feature1: "ADAS Level 2 with 20 Autonomous Features ",
    feature2: "Dual Pane Panoramic Sunroof (G1.5T)",
    feature3: "360 Degree Camera  Blind View Monitor",
    feature4: "Digital Key",
    feature5: "Next Generation Kia Connect with OTA Map and System Updates",
    feature6:
      "Black Leatherette Seats &amp; Offwhite Accents",
    feature7: "Rain Sensing Wipers",
    feature8: "",
  },


    {
    title: "X LINE",
    cost: "21,56,900",
    feature1: "ADAS Level 2 with 20 Autonomous Features",
    feature2: "Dual Pane Panoramic Sunroof (G1.5T)",
    feature3: "360 Degree Camera Blind View Monitor",
    feature4: "Digital Key",
    feature5: "Black Interiors with Black Leatherette seats Hunter Green Accents",
    feature6:
      "Rear Wiper and Washer ",
    feature6: "Rain Sensing Wipers",
    feature7: "",
  },
];

const CircleData = [
  {
    title: " Ivory Silver Gloss",
    color: "#9c9c98",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fi%20s%20gloss.webp?alt=media&token=3e560480-a58a-4cbb-b1d8-6c8749ada902",
  },
  {
    title: "Sparkling Silver",
    color: "#e0e0e0",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Clavis%2F08-d%20(1).png?alt=media&token=5055a992-3f7b-43fb-9369-4ff26b6dcea6",
  },
  {
    title: "Pewter Olive",
    color: "#3b493c",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fp%20o.webp?alt=media&token=c32cfa66-861e-437f-b3c1-4668239675ca",
  },
  {
    title: "Glacier White Pearl",
    color: "#b7bab9",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fgyp.webp?alt=media&token=c1ac4187-4da2-4654-9169-832feefae5c8",
  },
  {
    title: "Imperial Blue",
    color: "#2a2c71",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fib.webp?alt=media&token=9927e617-18ec-4bfd-a3e2-3fd338cf5110",
  },
  {
    title: "Gravity Grey",
    color: "#444444",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fgg.webp?alt=media&token=e27a663a-702c-419f-90ea-f435286b7b1b",
  },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/syros%2Fabp.webp?alt=media&token=544a01c5-4ecf-4887-adbc-e41051b00c37",
  },

];

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book The Carens Clavis ",
    desc: "For epic journeys.",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Know more about The Carens Clavis.",
    link: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/kia-clavis/brochure/Carens_Clavis_4_Page_Leaflet_Desktop.pdf",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];


const FaqData = [
  {
    question: "What is the new price of the Kia Carens Clavis Base Model after GST cut?",
    answer: "The official ex-showroom price of the Kia Carens Clavis base model starts at ₹ 11 07 829* after GST cut.",
  },
  {
    question: "What is the price of Kia Carens Clavis top Model after GST cut?",
    answer: "The official ex-showroom price of the Kia Carens Clavis top model i.e. Clavis HTX+ starts at ₹ 18 68 913* after GST cut.",
  },
  {
    question: "Does the Carens Clavis come with a sunroof?",
    answer:
      "Yes, selected variants of Carens Clavis top model comes with Sky Light Sunroof and Dual Pane Panoramic Sunroof.",
  },
  {
    question: "What are the seating options available in the Kia Clavis?",
    answer:
      "The Carens Clavis is a spacious 7 seater family car which comes with 4-way Power Driver’s Seat and Front Ventilated Seats and many other features.",
  },
  {
    question: "How many airbags are there in Kia Carens Clavis?",
    answer:
      "Kia Carens Clavis offers 6 airbags to ensure comprehensive safety for you and your loved ones.",
  },
  {
    question: "What are the engine and transmission options available in the 2025 Kia Carens Clavis?",
    answer:
      "The Kia Clavis offers three engine choices: a Smartstream G1.5 T-Gdi petrol engine with 6MT/ 6iMT/ 7DCT, a Smartstream G1.5 petrol engine with 6 speed manual transmission, and 1.5l CRDi VGT Diesel engine with 6MT/ 6 speed automatic transmission.",
  },

  {
    question: "How many features does the Kia Carens Clavis offer in its ADAS system?",
    answer:
      "The Kia Carens Clavis comes with ADAS Level 2 along with 20 autonomous safety features designed to keep you and your family secure through every mile.",
  },


  {
    question: "Does Kia Clavis have cruise control?",
    answer:
      "Yes, Kia Clavis have smart cruise control feature which automatically maintains distance and manages stop-and-go traffic.",
  },

  {
    question: "How many color options are available for the Kia Clavis?",
    answer:
      "Kia Carens Clavis is available in 8 Monotone Colours like Ivory Silver Gloss, Pewter Olive, Imperial Blue, Glacier White Pearl, Gravity Gray, Sparkling Silver, Aurora Black and Pearl Clear White colour.",
  },
];
//-----------------------------------------------------Pending--------------------------------------//

const StepData = [
  {
    title: "Kia Digital Tiger Face With Diamond Finish Decor",
    desc: "Command attention on every journy.",
  },
  {
    title: "Star Map LED DRLs with Integrated Turn Signals and Ice Cube MRF LED Headlamps",
    desc: "Illuminate the road ahead with cutting-edge precision , ensuring your loved ones always tarvel in safety and style.",
  },
  {
    title: "R17 - 43.66cm (17)Crystal Cut Dual Tone Alloy Wheels",
    desc: "Designed to turn heads at every corner, these wheels will take your drive up a notch.",
  },
  {
    title: "Star Map LED Connected Tail Lamps",
    desc: "A signature look that lights the way, leaving an indelible impression.",
  },
  {
    title:
      "Dual Pane Panoramic Sunroof ",
    desc: "Let the sunshine in! A wide, stunning view that brightens every family ride.",
  },
  {
    title: "67.62 cm (26.62)Dual Panoramic Display Panel",
    desc: "Navigate,control,and entertain with a seamless interface the whole family can enjoy.",
  },
];

export {
  // CarouselData,
  CarouselData1,
  TrimData,
  CircleData,
  DetailInfo,
  FaqData,
  StepData,
  BannerData,
  IntroData,
  InterestDealerData,
  // banner2Data,
};
